import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
    token: null,
    permissions: []
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    userPermissions: state => state.permissions
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      state.permissions = []
    }
  },
  actions: {
    login({ commit }, { token, user, permissions }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      commit('SET_PERMISSIONS', permissions)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
